import * as React from "react";
import { DndContext } from "@dnd-kit/core";
import { createGlobalStyle } from "styled-components";
import { setAutoFreeze } from "immer";
import { useLocalStorage, useMediaQuery } from "@uidotdev/usehooks";
import { Login } from "./Login";
import { Router } from "./Router";
import { IsoProvider } from "../isoContext";
import { jwtDecode } from "jwt-decode";
import { TrpcProvider } from "./TrpcProvider";
import "react-contexify/ReactContexify.css";
import "react-datepicker/dist/react-datepicker.css";

setAutoFreeze(false);

export function App() {
  const [token, setToken] = useLocalStorage<string | null>("token");
  const darkMode = useMediaQuery("(prefers-color-scheme: dark)");
  React.useEffect(() => {
    document.documentElement.setAttribute("data-bs-theme", darkMode ? "dark" : "light");
  }, [darkMode]);

  React.useEffect(() => {
    if (token) {
      const expiryLimit = Date.now() / 1000 - 60;
      const jwt = jwtDecode(token);
      if (!jwt.exp) return;
      const diff = jwt.exp - expiryLimit;
      if (diff < 0) {
        setToken(null);
      } else {
        const timer = setTimeout(() => setToken(null), diff * 1000);
        return () => clearTimeout(timer);
      }
    }
  }, [token]);

  return (
    <>
      <GlobalStyle />
      <TrpcProvider token={token}>
        <DndContext>
          <IsoProvider>{token ? <Router /> : <Login onLogin={setToken} />}</IsoProvider>
        </DndContext>
      </TrpcProvider>
    </>
  );
}

const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
  }
  html, body, #root {
    padding: 0;
    margin: 0;
    height: 100%;
    overflow: hidden;
  }
  html {
    font-family: Open Sans, sans-serif !important;
    --theme-color-primary: #36447e;
    --theme-color-light: #44559b;
    --bg-color: #f3f3f3;
    --box-color: #fff;
    --box-border-color: #eeeeee;
    --box-color-contrast: #e0e0e0;
    --box-color-hover: #f6f6f6;
    --text-light-color: #dcdddf;
    --text-primary-color: #000;
    --text-secondary-color: #333;
    --box-color-darken: rgba(0, 0, 0, 0.1);
    color: var(--text-primary-color);
  }
  .bn-block-content[data-content-type=checkListItem]>div {
    align-items: center;
  }
  @media (prefers-color-scheme: dark) {
    html {
      --bg-color: #333 !important;
      --box-color: #222 !important;
      --box-color-contrast: #393939 !important;
      --box-color-hover: #191919 !important;
      --text-primary-color: #bfc1c4ff !important;
      --text-secondary-color:rgba(163, 166, 169, 1) !important;
      --box-border-color: #555 !important;
    --box-color-darken: #191919 !important;
      color: #dee2e6;
    }
  }
`;
